export * from './providers/calendarEventTitleFormatter.provider';
export * from './providers/calendarMomentDateFormatter.provider';
export * from './providers/calendarNativeDateFormatter.provider';
export * from './providers/calendarDateFormatter.provider';
export * from './providers/calendarUtils.provider';
export * from './calendar.module';
export * from './components/day/calendarDayView.component';
export * from './components/month/calendarMonthView.component';
export * from './components/week/calendarWeekView.component';
export { DAYS_OF_WEEK } from 'calendar-utils';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/ggueret/Desktop/Personnel/Angular/ares-app/~/angular-calendar/dist/esm/src/index.js
// module id = ../../../../angular-calendar/dist/esm/src/index.js
// module chunks = 3